/* ROUGHCUT start page behaviour — ported from roughcut-start.html.
   Scoped by querying inside .rc-sp wherever it looks the document up, so a
   section that isn't on the page simply finds nothing and does nothing. */
(function(){
  if (window.__rcStartPageBooted) return;
  window.__rcStartPageBooted = true;


/* ES5 only. Shopify's asset minifier on this theme targets es5 and refuses
   const/arrow/template syntax — it reports "Minification failed" and then
   serves the file unminified, which is how the patterns page once shipped
   broken. Written this way from the start so the port is a copy. */
document.documentElement.className += ' rcjs';
function rcClamp(v){ return v<0?0:(v>1?1:v); }
var RC_REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── films ──
   No cleverness about detecting a blocked embed: there is no reliable way to
   ask a cross-origin iframe whether it painted, and the last attempt hid
   working videos. It plays, and the YouTube link stays visible throughout. */
(function(){
  var fs=document.querySelectorAll('.film');
  for(var n=0;n<fs.length;n++)(function(f){
    function play(ev){
      if(f.classList.contains('on')) return;
      if(ev){ ev.preventDefault(); ev.stopPropagation(); }
      var i=document.createElement('iframe');
      i.src='https://www.youtube.com/embed/'+f.getAttribute('data-yt')+
            '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      i.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      i.setAttribute('allowfullscreen',''); i.setAttribute('frameborder','0');
      f.appendChild(i); f.classList.add('on');
    }
    var b=f.querySelector('.play'); if(b) b.onclick=play;
    f.addEventListener('click',function(ev){
      var t=ev.target;
      while(t && t!==f){
        if(t.className && (''+t.className).indexOf('ytOut')>-1) return;
        t=t.parentNode;
      }
      play(ev);
    });
  })(fs[n]);
})();

/* ── SET PIECE 1 · the lockstitch ─────────────────────────────────────
   The outline is traced from the scan of Jack's own machine. The motion is
   the real four-part cycle rather than a loop of tweens, because the timing
   between the parts is the whole lesson:

     · needle bar hangs off a crank — sine motion, fast through the middle
       of the stroke and slow at each end, which is why you can stop it
       exactly at top dead centre with the handwheel
     · take-up lever runs a quarter cycle AHEAD of the needle, so the slack
       is pulled up the instant the needle clears the fabric — that is what
       actually forms the stitch
     · rotary hook is geared 2:1. It passes the needle once per stroke to
       catch the loop, and spins through a second time doing nothing
     · feed dogs walk an ellipse: up and back while the needle is clear,
       down and forward underneath while the needle is in the cloth. They
       only ever move the fabric when nothing is stitched through it

   Three stitches, not nine — nine was a long scroll for a point made in one. */
(function(){
  var wrap=document.getElementById('machine');
  if(!wrap) return;
  var wheelG=document.getElementById('wheelG'), crankG=document.getElementById('crankG'),
      link=document.getElementById('link'), needlebar=document.getElementById('needlebar'),
      hookG=document.getElementById('hookG'), feed=document.getElementById('feed'),
      foot=document.getElementById('foot'), thread=document.getElementById('thread'),
      tuArm=document.getElementById('tuArm'), tuEye=document.getElementById('tuEye'),
      fabric=document.getElementById('fabric'), stitches=document.getElementById('stitches'),
      spokes=document.getElementById('spokes'), rpm=document.getElementById('rpm'),
      rNeedle=document.getElementById('rNeedle'), rHook=document.getElementById('rHook'),
      rStitch=document.getElementById('rStitch'), mechH=document.getElementById('mechH'),
      mechP=document.getElementById('mechP');

  var sv='';
  for(var s=0;s<8;s++){
    var a=s*45*Math.PI/180;
    sv+='<line class="faint" x1="'+(867+12*Math.cos(a)).toFixed(1)+'" y1="'+(162+12*Math.sin(a)).toFixed(1)+
        '" x2="'+(867+74*Math.cos(a)).toFixed(1)+'" y2="'+(162+74*Math.sin(a)).toFixed(1)+'"/>';
  }
  spokes.innerHTML=sv;

  var CYCLES=3, PITCH=46, STROKE=60, TAU=Math.PI*2;
  var sm=0, last=0, lastT=0, placed=0;

  function draw(p){
    var cyc=p*CYCLES, th=cyc*TAU, deg=th*180/Math.PI;
    var n=Math.floor(cyc), a=(cyc-n)*TAU;          /* angle within this stitch */

    wheelG.setAttribute('transform','rotate('+deg+' 867 162)');
    crankG.setAttribute('transform','rotate('+deg+' 250 162)');

    /* crank-slider: needle bar follows (1-cos)/2, not a linear ramp */
    var ny=(1-Math.cos(th))/2*STROKE;
    needlebar.setAttribute('transform','translate(0 '+ny+')');
    foot.setAttribute('transform','translate(0 '+(Math.max(0,-Math.cos(th))*1.5)+')');
    link.setAttribute('y1',(162+30*Math.sin(th-Math.PI/2)).toFixed(1));
    link.setAttribute('y2',(236+ny).toFixed(1));

    /* take-up: a quarter cycle ahead of the needle */
    var tu=Math.cos(th-Math.PI/2)*30;
    tuArm.setAttribute('d','M232 196 L182 '+(196+tu).toFixed(1));
    tuEye.setAttribute('cy',(196+tu).toFixed(1));

    hookG.setAttribute('transform','rotate('+(deg*2)+' 250 522)');

    /* feed dogs walk an ellipse — up and back, then down and forward */
    var fx=-Math.sin(a)*13, fy=-Math.max(0,Math.cos(a))*7;
    feed.setAttribute('transform','translate('+fx.toFixed(1)+' '+fy.toFixed(1)+')');

    /* the fabric only moves while the dogs are up and the needle is out.
       Feeding finishes exactly as the needle tip reaches the cloth. */
    var f = a<Math.PI/2 ? Math.sin(a) : 1;
    var adv=(n+f)*PITCH;
    fabric.setAttribute('transform','translate('+(-adv).toFixed(1)+' 0)');

    /* a stitch is locked at the bottom of each stroke. Drawn in fabric
       coordinates so it travels with the cloth, and removed again if the
       reader scrolls back up. */
    var done=Math.floor(cyc+0.5), html='', k;
    if(done!==placed){
      placed=done<0?0:done;
      for(k=1;k<=placed;k++){
        var x=250+k*PITCH;
        html+='<line class="thread" x1="'+(x-PITCH+7)+'" y1="440" x2="'+(x-7)+'" y2="440"/>';
      }
      stitches.innerHTML=html;
    }

    /* thread runs spool → tension → take-up eye → needle bar → needle eye,
       and visibly slackens and pulls taut as the lever swings */
    var ey=196+tu;
    thread.setAttribute('d',
      'M251 27 Q214 '+(46+tu*0.2).toFixed(1)+' 196 '+(96+tu*0.3).toFixed(1)+
      ' Q180 '+(140+tu*0.5).toFixed(1)+' 182 '+ey.toFixed(1)+
      ' Q214 '+(ey+26).toFixed(1)+' 250 '+(250+ny).toFixed(1)+
      ' L250 '+(392+ny).toFixed(1));

    if(rNeedle) rNeedle.textContent = ny<7?'top' : (ny>STROKE-7?'bottom' :
                                     (Math.sin(th)>0?'descending':'rising'));
    if(rHook) rHook.textContent=Math.round((deg*2)%360)+'\u00b0';
    if(rStitch) rStitch.textContent=(placed<10?'0':'')+placed;
  }

  if(RC_REDUCE){ draw(0.7); mechH.style.opacity=1; mechP.style.opacity=1; return; }

  function frame(now){
    var r=wrap.getBoundingClientRect();
    if(r.bottom>-200 && r.top<innerHeight+200){
      var total=r.height-innerHeight;
      sm += ((total>0?rcClamp(-r.top/total):0)-sm)*0.11;
      draw(sm);
      var dt=(now||0)-lastT; lastT=now||0;
      rpm.textContent=Math.round(Math.min(Math.abs(sm-last)/(dt||16)*1000*CYCLES*60,1400))+' RPM';
      last=sm;
      mechH.style.opacity=rcClamp((sm-0.22)/0.2);
      mechP.style.opacity=rcClamp((sm-0.34)/0.2);
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

/* ── SET PIECE 2 · the exploded tote ────────────────────────────────── */
(function(){
  var wrap=document.getElementById('tote');
  if(!wrap) return;
  var pieces=document.querySelectorAll('.piece'),
      cnt=document.getElementById('cnt'), pinH=document.getElementById('pinH'),
      pinP=document.getElementById('pinP'), becomes=document.getElementById('becomes'), z;

  if(RC_REDUCE){
    for(z=0;z<pieces.length;z++){
      pieces[z].style.opacity=1; pieces[z].style.transform='none';
    }
    cnt.textContent='07 / 07 pieces';
    if(becomes) becomes.className='becomes on';
    pinH.style.opacity=1; pinP.style.opacity=1;
    return;
  }

  var sm=0;
  function frame(){
    var r=wrap.getBoundingClientRect();
    if(r.bottom>-200 && r.top<innerHeight+200){
      var total=r.height-innerHeight;
      sm += ((total>0?rcClamp(-r.top/total):0)-sm)*0.09;
      var n=pieces.length, span=1/n, done=0, i;
      for(i=0;i<n;i++){
        var p=pieces[i], t=rcClamp((sm-i*span*0.82)/(span*1.9));
        t=t*t*(3-2*t);                                  /* smoothstep */
        p.style.opacity=t;
        p.style.transformOrigin='300px 250px';
        p.style.transform='translate('+((+p.getAttribute('data-dx'))*(1-t))+'px,'+
          ((+p.getAttribute('data-dy'))*(1-t))+'px) rotate('+
          ((+p.getAttribute('data-rot'))*(1-t))+'deg)';
        if(t>0.6) done++;
      }
      cnt.textContent=(done<10?'0':'')+done+' / 07 pieces';
      /* the photograph is the payoff, so it waits for the last piece */
      if(becomes) becomes.className = done===n ? 'becomes on' : 'becomes';
      var hOn=rcClamp((sm-0.55)/0.25);
      pinH.style.opacity=hOn;
      pinH.style.transform='translateY('+((1-hOn)*20)+'px)';
      pinP.style.opacity=rcClamp((sm-0.72)/0.2);
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

/* ── the skill finder ───────────────────────────────────────────────────
   The live version asked three questions and then linked to "#". Three
   questions of investment with no payoff is worse than no quiz at all.

   Scored 0–6, bands deliberately generous at the bottom: someone unsure is
   better served finishing a tote than being flattered into a jacket they
   abandon halfway. */
(function(){
  var quiz=document.getElementById('quiz');
  if(!quiz) return;
  var steps=quiz.querySelectorAll('.qstep'), bar=document.getElementById('qbar');
  var score=0, at=0;

  var PICKS=[
    { max:1, lvl:'Level 1 · Start here', name:'The Industrial Tote Bag',
      why:'Straight seams on heavy fabric, and you can finish it in an evening. It teaches how a pattern goes together without punishing you for getting anything wrong — and it is free, so there is nothing to lose by trying it.',
      href:'#free' },
    { max:3, lvl:'Level 2 · Confident beginner', name:'The Core Hoodie',
      why:'You know your way around the machine, so the tote would bore you. The hoodie is forgiving fabric with real garment construction in it — hood, ribbing, a shoulder seam that has to sit right. The first thing you will actually wear.',
      href:'/products/the-core-hoodie-sewing-pattern' },
    { max:5, lvl:'Level 3 · Intermediate', name:'The Terrace Jacket',
      why:'You have made garments before, so you want structure rather than another easy win. Elastic finishes, a proper collar and a front zip — everything an outer layer needs, without the weight of denim fighting you.',
      href:'/products/the-terrace-jacket-sewing-pattern' },
    { max:6, lvl:'Level 4 · Advanced', name:'The Keystone Denims',
      why:'You can already build clothes, so start where the depth is. A full modular selvedge denim course with multiple construction pathways — fly, pockets, waistband, hardware. This is the one people work toward.',
      href:'/products/the-keystone-denims-modular-selvedge-jeans-sewing-pattern' }
  ];

  function show(i){
    for(var k=0;k<steps.length;k++)
      steps[k].className='qstep'+(k===3?' qres':'')+(k===i?' on':'');
    bar.style.width=Math.round(((i+1)/steps.length)*100)+'%';
    at=i;
  }
  /* The answer buttons are rebuilt as three children each, so the click has to
     be read off the button rather than off whatever span was under the cursor. */
  function finish(){
    var p=PICKS[0];
    for(var k=0;k<PICKS.length;k++){ if(score<=PICKS[k].max){ p=PICKS[k]; break; } }
    document.getElementById('qlvl').textContent=p.lvl;
    document.getElementById('qname').textContent=p.name;
    document.getElementById('qwhy').textContent=p.why;
    document.getElementById('qlink').setAttribute('href',p.href);
    show(3);
  }
  var opts=quiz.querySelectorAll('.opt');
  for(var i=0;i<opts.length;i++){
    opts[i].onclick=function(){
      score+=parseInt(this.getAttribute('data-s'),10)||0;
      if(at<2) show(at+1); else finish();
    };
  }
  document.getElementById('qagain').onclick=function(){ score=0; show(0); };
  show(0);
})();

/* ── reveal ──
   classList, not className.indexOf: 'origin' contains 'in', and that exact
   bug once left a whole block stuck at opacity:0 on the product pages. */
(function(){
  var els=document.querySelectorAll('[data-rv]'), i;
  function show(el){ el.classList.add('in'); }
  if(!('IntersectionObserver' in window)){
    for(i=0;i<els.length;i++) show(els[i]); return;
  }
  var io=new IntersectionObserver(function(es){
    for(var k=0;k<es.length;k++) if(es[k].isIntersecting){ show(es[k].target); io.unobserve(es[k].target); }
  },{rootMargin:'0px 0px -8% 0px'});
  for(i=0;i<els.length;i++){
    els[i].style.transitionDelay=((els[i].getAttribute('data-d')||0)*0.08)+'s';
    io.observe(els[i]);
  }
  /* fail open: anything already near the viewport shows regardless */
  setTimeout(function(){
    for(var k=0;k<els.length;k++)
      if(els[k].getBoundingClientRect().top<window.innerHeight*1.2) show(els[k]);
  },80);
})();

})();
